import {
    useManagedSchoolsQuery,
  } from '../../../generated/graphqlModels';
import { CLASSROOM_CONFIG } from '../pages/Licenses/index/config';

export const useCanCreateClassroom = () => {
    const { data, loading, error } = useManagedSchoolsQuery();
    
    const canCreateClassroom = data?.managedSchools?.some((school) => {
        const hasUserAffiliation = school.affiliation && 
          (school.affiliation.isTeacher || school.affiliation.isManager);
        const isAllowedNamespace = CLASSROOM_CONFIG.ALLOWED_NAMESPACES.includes(
          (school as unknown as { namespace: string }).namespace
        );
        return hasUserAffiliation && isAllowedNamespace;
      });

    return {
        canCreateClassroom,
        loading,
        error,
    };
};